import { render, staticRenderFns } from "./AdminAlertPlanNumberList.vue?vue&type=template&id=fd9a4716"
import script from "./AdminAlertPlanNumberList.vue?vue&type=script&lang=js"
export * from "./AdminAlertPlanNumberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports